import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { Socket, io } from 'socket.io-client';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  private socket: Socket;

  public message = [];

  constructor(private auth: AuthService) {
    this.socket = io('https://aieventzo.com:2096');

    this.socket.on('check_user_status', (data) => {
      console.log('Socket triggered checkStatus');
      this.auth.checkStatus(); // Calling the function here
    });
  }

  public sendMessage(message: any) {
    console.log(message);
    
    this.socket.emit('message', message);
  }

  public Refresh() {
    console.log("refresh");
    
    return new Observable((observer: Observer<any>) => {
      this.socket.on('refresh', (action: any) => {
        observer.next(action)
      })
    })
  }

  public regrefresh(action: any) {
    console.log("regrefresh");
    this.socket.emit('refresh', action);
  }


}
